import { createSlice } from '@reduxjs/toolkit';

export const filterInitialState = {
  filtersContext: '',
  onApplySelectedFilters: 0,
  onApplySelectedFiltersToAllPlatforms: 0,
  isOpenSidebarFilters: false,
  subjectsTwitter: {
    selectedSubjects: [],
  },
};

export const filterSlice = createSlice({
  name: 'filterSlice',
  initialState: filterInitialState,
  reducers: {
    setFiltersContext: (state, action) => {
      state.filtersContext = action.payload;
    },
    toggleSidebarFilters: (state, action) => {
      state.isOpenSidebarFilters = action.payload;
    },
    applyFiltersToApiRequest: (state) => {
      state.onApplySelectedFilters = state.onApplySelectedFilters + 1;
    },
    applyFiltersToAllPlatforms: (state) => {
      state.onApplySelectedFiltersToAllPlatforms =
        state.onApplySelectedFiltersToAllPlatforms + 1;
    },
  },
});

export const {
  setFiltersContext,
  toggleSidebarFilters,
  applyFiltersToApiRequest,
  applyFiltersToAllPlatforms,
} = filterSlice.actions;
